module.exports = __webpack_public_path__ + "static/media/thumb_WFVQ9920_1024.849f78ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/thumb_WFVQ9920_1024.jpg
// module id = 138
// module chunks = 0